import { Head, useForm } from "@inertiajs/react";
import PlainLayout from "@/layouts/plain-layout";
import { password_path } from "@/routes";

function EditPassword({ token }) {
  const { data, setData, put, processing } = useForm({
    password: "",
    password_confirmation: ""
  });

  const submit = (e) => {
    e.preventDefault();
    put(password_path(token));
  };

  return (
    <>
      <Head title="Ændr adgangskode" />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm rounded-4 border-0">
              <div className="card-body p-4">
                <h1 className="h4 text-center fw-semibold mb-4">Ændr din adgangskode</h1>
                <form className="vstack gap-3" onSubmit={submit}>
                  <div>
                    <label className="form-label">Ny adgangskode</label>
                    <input className="form-control rounded-3" type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} required />
                  </div>
                  <div>
                    <label className="form-label">Bekræft ny adgangskode</label>
                    <input className="form-control rounded-3" type="password" value={data.password_confirmation} onChange={(e) => setData("password_confirmation", e.target.value)} required />
                  </div>
                  <button className="btn btn-primary w-100 rounded-3 py-2 fw-semibold" disabled={processing}>Gem</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

EditPassword.layout = (page) => <PlainLayout>{page}</PlainLayout>;

export default EditPassword;
